import React, { Component } from 'react'
import { Card, Tab, Tabs, TabsContainer } from 'react-md'

import { Reloadable } from 'components'
import { Artworks } from 'containers'
import { ArtworkStatus } from 'api/enums'
import * as routes from 'routes'

import './index.css'

class ExportArtworks extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: 0
    }

    this.handleTabChange = this.handleTabChange.bind(this)
  }

  handleTabChange (newTabIndex) {
    this.setState({
      activeTab: newTabIndex
    })
  }

  render () {
    const { activeTab } = this.state

    return (
      <Card>
        <TabsContainer
          slideHeightProp='maxHeight'
          className='export-artworks-tabs'
          onTabChange={this.handleTabChange}
        >
          <Tabs tabId='export-artwork'>

            <Tab label='Pending'>
              { activeTab === 0 && (
                <Artworks
                  noCard
                  enablePublish
                  disableDelete
                  baseId='pending-artworks'
                  title='Pending Artworks'
                  artworkStatus={ArtworkStatus.PENDING}
                  noArtworksMessage='No pending artworks.'
                  artworkClickRoute={routes.exportArtwork}
                />
              ) }
            </Tab>

            <Tab label='Published'>
              { activeTab === 1 && (
                <Artworks
                  noCard
                  enableUnpublish
                  disableDelete
                  baseId='published-artworks'
                  title='Published Artworks'
                  artworkStatus={ArtworkStatus.PUBLISHED}
                  noArtworksMessage='No published artworks.'
                  artworkClickRoute={routes.exportArtwork}
                />
              ) }
            </Tab>
          </Tabs>
        </TabsContainer>
      </Card>
    )
  }
}

export default Reloadable(ExportArtworks)



// WEBPACK FOOTER //
// ./src/containers/ExportArtworks/index.js